import React, { useState } from 'react';
import { Globe } from 'lucide-react';
export function LanguageToggle() {
  const [language, setLanguage] = useState<'en' | 'es'>('en');
  return <button onClick={() => setLanguage(language === 'en' ? 'es' : 'en')} className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors" aria-label="Toggle language" data-id="element-240">
      <Globe className="w-4 h-4 text-gray-600" data-id="element-241" />
      <span className="text-sm font-medium text-gray-700" data-id="element-242">
        {language === 'en' ? 'EN' : 'ES'}
      </span>
    </button>;
}